import { render, staticRenderFns } from "./appreceived.vue?vue&type=template&id=11469025&"
import script from "./appreceived.vue?vue&type=script&lang=js&"
export * from "./appreceived.vue?vue&type=script&lang=js&"
import style0 from "./appreceived.vue?vue&type=style&index=0&id=11469025&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports